import { fontSizeInPx } from '@leagueplatform/ui-kit';
import styled from 'styled-components';

export const BreadcrumbItem = styled.span`
  font-weight: normal;
  font-size: ${fontSizeInPx(2)};
`;
